import * as tslib_1 from "tslib";
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
let HAttachment = class HAttachment extends Vue {
    constructor() {
        super(...arguments);
        this.showTemp = true;
    }
    displayTemplateChange(val) {
        this.showTemp = val;
    }
};
tslib_1.__decorate([
    Prop({
        default: ''
    })
], HAttachment.prototype, "text", void 0);
tslib_1.__decorate([
    Prop({
        default: true
    })
], HAttachment.prototype, "displayTemplate", void 0);
tslib_1.__decorate([
    Watch('displayTemplate', {
        immediate: true,
        deep: true
    })
], HAttachment.prototype, "displayTemplateChange", null);
HAttachment = tslib_1.__decorate([
    Component({
        name: 'h-attachment'
    })
], HAttachment);
export default HAttachment;
